import axios from 'axios';
import { API_URL } from '../config';
import { transformPayload } from './utils';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}

const transformEmployeePayload = (employee: any) => {
  const propsToChange: Record<string, string> = {
    'education_level': 'education_level_id',
    'citizenship': 'citizenship_id',
    'domicilio_comune': 'domicilio_comune_id',
    'residence_permit_police_hq': 'residence_permit_police_hq_id',
    'residence_permit_type': 'residence_permit_type_id',
    'residence_permit_reason': 'residence_permit_reason_id',
    'location': 'location_id',
  };

  transformPayload(employee, propsToChange);
};

export const updateAnagraficaEmployee = async (
    token: string, 
    id: number, 
    data: object
  ) => {
    // transformEmployeePayload(data);
    const response = await axios.patch(`${API_URL}/presenze/employee/${id}/`, data, {
      headers: {
        'Authorization': token,
      },
    });
    return response.data;  
  };

export const getLocationsCompany = async (token: string, q: string | null) => {
  const params: Record<string, any> = {};

  if(q)
    params['q'] = q;

  const response = await axios.get(`${API_URL}/presenze/company/locations/?${new URLSearchParams(params).toString()}`, {
    headers: {
      'Authorization': token,
    }
  });
  return response.data;
};

export const getLocationsCompanyPaginated = async (
  token: string, 
  page: number, 
  pageSize: number = 1,
  permission: string | null,
) => {
  const response = await axios.get(`${API_URL}/locations/`, {
    headers: {
      'Authorization': token,
    },
    params: {
      page: page,
      page_size: pageSize,
    },
    permission,
  } as CustomAxiosRequestConfig);
  return response.data;
};
